import React, { useEffect, useState } from "react";
import { MenuItem, Select, FormControl, Snackbar, Alert } from "@mui/material";
import { useGetAvailableRolesQuery, useChangeRoleMutation } from "../../../../services/ProfileService";

interface RoleSelectProps {
  value?: string;
  onChange: (value: string) => void;
  initialValue?: string;
  identity?: string;
  disabled?: boolean;
}

export const RoleSelect: React.FC<RoleSelectProps> = ({ value, onChange, initialValue, identity, disabled }) => {
  const { data: allowedRoles = [], isLoading } = useGetAvailableRolesQuery();
  const [internalValue, setInternalValue] = useState(initialValue || "");
  const [changeRole] = useChangeRoleMutation();
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (initialValue && !value) {
      setInternalValue(initialValue);
      onChange(initialValue);
    }
  }, [initialValue]);

  const handleChange = async (val: string) => {
    setInternalValue(val);
    onChange(val);
    if (identity) {
      try {
        await changeRole({ identity, role: val }).unwrap();
      } catch (e: any) {
        setError(e?.data?.message || e?.error || "Failed to change role");
        setOpen(true);
      }
    }
  };

  return (
    <>
      <FormControl size="small" sx={{ minWidth: 500, height: 40 }}>
        <Select
          labelId="role-select-label"
          value={value ?? internalValue}
          onChange={e => handleChange(e.target.value as string)}
          disabled={isLoading || disabled}
          sx={{ height: 40, display: 'flex', alignItems: 'center' }}
        >
          {allowedRoles.map((role: { name: string }) => (
            <MenuItem key={role.name} value={role.name}>{role.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Snackbar open={open} autoHideDuration={4000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setOpen(false)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};
